import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'mobx-react';
import root from './stores';
import { ToastProvider } from './components/layouts/ToastProvider';
import '../node_modules/react-vis/dist/style.css'

ReactDOM.render(
  <React.StrictMode>
    <Provider root={root}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
